import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
} from "@angular/core";
import { PageLoadingIndicatorComponent } from "../page-loading-indicator/page-loading-indicator.component";

@Component({
  selector: "app-page-loading",
  templateUrl: "./page-loading.component.html",
  styleUrl: "./page-loading.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [PageLoadingIndicatorComponent],
})
export class PageLoadingComponent {
  readonly isOpaque = input(false);
  readonly title = input<string>();
}
